import { ReactNode } from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <div className="min-h-screen grid grid-rows-[auto_1fr_auto]">

      <header className="sticky top-0 z-50 bg-white">
        <Header />
      </header>


      {/* Scrollable center */}
      <main className=" flex justify-center items-stretch">
        <div className="w-full">
          {children}
        </div>
      </main>

      {/* Footer */}
      <footer>
        <Footer />
      </footer>
    </div>
  );
};

export default Layout;

// import { ReactNode } from 'react';
// import Header from '../Header/Header';
// import Footer from '../Footer/Footer';

// interface LayoutProps {
//   children: ReactNode;
// }

// const Layout = ({ children }: LayoutProps) => {
//   return (
//     <div className="h-screen overflow-hidden grid grid-rows-[auto_1fr_auto]">
//       {/* Header */}
//       <header>
//         <Header />
//       </header>

//       {/* Scrollable center */}
//       <main className="overflow-y-auto flex justify-center items-stretch">
//         <div className="w-full">
//           {children}
//         </div>
//       </main>

//       {/* Footer */}
//       <footer>
//         <Footer />
//       </footer>
//     </div>
//   );
// };

// export default Layout;

